// extracted by mini-css-extract-plugin
export default {"eye_chart_font":"visualAcuity_eye_chart_font__32IO2","snellen_chart_font":"visualAcuity_snellen_chart_font__l71kw","sloan_chart_font":"visualAcuity_sloan_chart_font__9wKEa"};